export default __webpack_public_path__ + "static/media/plus.eef5204c.svg";